/*
  Message Linked Task Display Component Controller

  EMITTED EVENTS
    update-success (document) Emitted when removeLinkTarget request succeeds and shouldRemove is false
      detail: {
        el:         the root element of this controller instance,
        message_id: the parent-message-id data attribute value
      }
*/

import { createCustomEvent } from '../../../../javascript/shared/helpers';

export default class extends Controller {
  static targets = ['removeLink'];

  removeTaskLink(event) {
    event.preventDefault();
    if (confirm('Are you sure you want to remove the link to this task?')) {
      App.Helpers.ajaxRequest({
        url: this.removeURL,
        method: 'delete',
        data: { _method: 'delete' },
        successHandler: this.shouldRemove ? this.removeMessage.bind(this) : this.emitUpdateSuccessEvent.bind(this)
      })
    }
  }

  removeMessage() {
    this.element.closest('.messages--message-div').remove();
  }

  emitUpdateSuccessEvent() {
    document.dispatchEvent(createCustomEvent('update-success', this.element, { message_id: this.parentMessageID }));
  }

  //
  // GETTERS AND SETTERS
  //

  get removeURL() {
    return this.data.get('remove-url');
  }

  get shouldRemove() {
    return this.data.get('should-remove') == '1';
  }

  get parentMessageID() {
    return this.data.get('parent-message-id');
  }
};



// WEBPACK FOOTER //
// ./app/components/messages/assets/javascript/message-linked-task-display-controller.js